export function handleFullscreenChange() {
  const paneNode = this.mapPaneRef.current;
  const isMapFullscreen = !!paneNode && document.fullscreenElement === paneNode;
  this.setState({ isMapFullscreen });
  if (this.map) {
    setTimeout(() => this.map.resize(), 0);
  }
}

export async function toggleMapMaximize() {
  const paneNode = this.mapPaneRef.current;
  if (!paneNode) return;
  const supportsFullscreen =
    typeof paneNode.requestFullscreen === 'function' &&
    typeof document.exitFullscreen === 'function';
  if (!supportsFullscreen) {
    this.setState(
      prevState => ({
        isMapMaximizedFallback: !prevState.isMapMaximizedFallback
      }),
      () => {
        if (this.map) {
          setTimeout(() => this.map.resize(), 0);
        }
      }
    );
    return;
  }
  try {
    if (document.fullscreenElement === paneNode) {
      await document.exitFullscreen();
      return;
    }
    if (document.fullscreenElement) {
      await document.exitFullscreen();
    }
    await paneNode.requestFullscreen();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Toggling map fullscreen failed', error);
  } finally {
    if (this.map) {
      setTimeout(() => this.map.resize(), 0);
    }
  }
}
